import React, { useCallback } from 'react';
import styled from 'styled-components';
import { ReportsTable } from '../ReportGroup';
import { faGear } from '@fortawesome/pro-light-svg-icons';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';

interface MoreItemProps {
  item: React.PropsWithChildren<{
    row: ReportsTable;
    index: number;
    className?: string;
  }>;
  handleMore: (item: { row: ReportsTable; index: number }) => unknown;
}

const StyledDiv = styled.td`
  cursor: default;
  text-align: center;
  .more-item {
    font-size: 12px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: ${SPACERS.extraTiny};
    transition: all 0.4s !important;
    color: ${COLORS.ctaPrimary};
    * {
      transition: all 0.1s !important;
    }
    svg {
      margin-right: 0 !important;
      fill: ${COLORS.ctaPrimary};
    }
    &:hover {
      color: ${COLORS.ctaBrand};
    }
    &:hover path {
      fill: ${COLORS.ctaBrand};
    }
  }
`;

const MoreItem: React.FC<MoreItemProps> = ({ item, handleMore }) => {
  const handlePrevention = useCallback(
    (e: React.MouseEvent<HTMLDivElement | SVGSVGElement>) => {
      e.preventDefault();
      e.stopPropagation();
    },
    [],
  );

  const handleMoreClick = useCallback(() => {
    handleMore(item);
  }, [item]);

  return (
    <StyledDiv className={item.className} onClick={handlePrevention}>
      <TrueImpactText className="more-item" onClick={handleMoreClick}>
        <FontAwesomeIcon icon={faGear} /> Actions
      </TrueImpactText>
    </StyledDiv>
  );
};

export default React.memo(MoreItem);
